import React, { useEffect, useState } from 'react';
import { contracts } from '../api';
import { Button, Modal, notification, Tooltip, Flex, Spin } from 'antd';
import {
  EditOutlined,
  FileDoneOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import ContractDetail from './ContractDetail';
import RejectionPopup from './RejectionPopup';
import { convertDate, extractContract } from './usefulFunctions';
import SowDrawer from '../projectPages/SowDrawer';
import PoDrawer from '../projectPages/PoDrawer';
import CrDrawer from '../projectPages/CrDrawer';
import { useNavigate } from 'react-router-dom';
import { userRole, employeeId } from '../../GetRole.utils';

const SowDetail = ({ id }) => {
  const navigate = useNavigate();
  const [sowContractDetailArr, setSowContractDeatilArr] = useState([]);
  const [contractStatus, setContractStatus] = useState();
  const [activationDate, setActivationDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [showBtn, setShowBtn] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [isRejectionModelOpen, setIsRejectionModelOpen] = useState(false);
  const [rejectionKey, setRejectionKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sowNo, setSowNo] = useState('N/A');
  const [seId, setSeId] = useState();
  const [clientId, setClientId] = useState();
  const [apiHit, setApiHit] = useState(false);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
      style: {
        padding: '9px 24px',
      },
    });
  };

  const showRejectionModel = (key) => {
    setRejectionKey(key);
    setIsRejectionModelOpen(true);
  };

  const handleRejectionPopupCanacel = () => {
    setRejectionKey(null);
    setIsRejectionModelOpen(false);
  };

  const showModal = (key) => {
    setSelectedKey(key);
    setIsModalOpen(true);
    setApiHit(!apiHit);
  };

  const handlePopupCancel = () => {
    setSelectedKey(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    try {
      contracts
        .getContractsData(id)
        .then((res) => {
          const data = res.data[0].contractData;
          setClientId(data?.client?.clientId);
          setSowNo(data?.sowNumber);
          setContractStatus(data.cStatus);
          setActivationDate(data.activationDate);
          setExpiryDate(data.expiryDate);
          setSeId(data.seId);

          const arr = [
            {
              label: 'Client Name :',
              labelValue: data.client.legalEntityName,
              key: 'client',
              redirection: true,
              redirectionURL: `/clients/${data.client.clientId}`,
            },
            {
              label: 'Contract Type :',
              labelValue: extractContract(data.contractType),
              key: 'contractType',
            },
            {
              label: 'Start Date :',
              labelValue: data.activationDate,
              key: 'activationDate',
            },
            {
              label: 'End Date :',
              labelValue: data.expiryDate,
              key: 'expiryDate',
            },
            {
              label: 'Project Name :',
              labelValue: data.project.projectName,
              key: 'project',
              redirection: true,
              redirectionURL: `/projects/${data.project.projectId}`,
            },
            {
              label: 'Spanidea Signatory :',
              labelValue: data.spanideaAuthorizerEmpName.empName,
              key: 'spanideaAuthorizerEmpName',
            },
            {
              label: 'Client Signatory -',
              labelValue: data.clientAuthorizer,
              type: 'singleTable',
              key: 'clientAuthorizer',
            },
            {
              label: 'Client Point Of Contact -',
              labelValue:
                data.pocDetail.flag == null
                  ? {
                      name: data.pocDetail.name,
                      email: data.pocDetail.email,
                      number: data.pocDetail.number,
                    }
                  : '',
              type: 'singleTable',
              key: 'pocDetail',
            },
            {
              label: 'Leaves Term :',
              labelValue: data.leavesTerm,
              key: 'leavesTerm',
            },
            {
              label: 'Leaves Allowed :',
              labelValue: data.leavesAllowed,
              key: 'leavesAllowed',
            },
            {
              label: 'Payment Term :',
              labelValue: `Net ${data.paymentTerm} Days`,
              key: 'paymentTerm',
            },
            {
              label: 'Payment Type:',
              labelValue: data.paymentType,
              key: 'paymentType',
            },
            {
              label: 'Last Upated On :',
              labelValue: data.updatedAt,
              key: 'updatedAt',
            },
            {
              label: 'Status :',
              labelValue: data.cStatus,
              key: 'cStatus',
            },
          ];

          if (data.paymentType === 'Milestones') {
            const obj = {
              label: '',
              labelValue: data.milestone,
              type: 'table',
              columns: [
                {
                  title: 'Milestone No.',
                  dataIndex: 'index',
                  key: 'index',
                  width: '13%',
                  render: (_, __, index) => `${index + 1}.`,
                },
                {
                  title: 'Deliverable Name',
                  dataIndex: 'milestoneName',
                  key: 'milestoneName',
                  width: '29%',
                },
                {
                  title: 'Payment %',
                  dataIndex: 'milestonePercentage',
                  key: 'milestonePercentage',
                  width: '29%',
                  render: (_, record) => `${record.milestonePercentage}%`,
                },
                {
                  title: 'Invoice Date',
                  dataIndex: 'milestoneDate',
                  key: 'milestoneDate',
                  width: '29%',
                },
              ],
              key: 'milestone',
            };
            arr.splice(12, 0, obj);
          } else {
            const obj = {
              label: 'Invoice Tenure:',
              labelValue: data.invoiceTenure,
              key: 'invoiceTenure',
            };
            arr.splice(12, 0, obj);
          }

          setSowContractDeatilArr(arr);
          setLoading(false);
        })
        .catch((error) => console.error('Error fetching data:', error));
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [isModalOpen, showBtn, isRejectionModelOpen]);

  const handleApproval = (status, succcessfulMessage) => {
    const postData = {
      cStatusId: status,
      activationDate: convertDate(activationDate),
      createdBy: employeeId,
    };
    contracts
      .updateContractsData(id, postData)
      .then((res) => {
        openNotificationWithIcon('success', succcessfulMessage);
        setShowBtn((prevshowBtn) => !prevshowBtn);
        setIsRejectionModelOpen(!isRejectionModelOpen);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon('error', err.response.data.message);
      });
  };

  const approvalButtons = () => {
    switch (contractStatus) {
      case 'draft':
        return (
          <>
            {userRole !== 'finance' && (
              <Tooltip title="Send For Approval" key={'Send For Approval'}>
                <Button
                  type="link"
                  icon={<FileDoneOutlined />}
                  style={{
                    // backgroundColor: '#52c41a',
                    color: '#52c41a',
                  }}
                  onClick={() =>
                    handleApproval(2, 'Contract sent for Approval')
                  }
                ></Button>
              </Tooltip>
            )}
          </>
        );

      case 'pendingapproval':
        return (
          <>
            {userRole !== 'bdTeam' && (
              <>
                <Tooltip title="Approve" key={'Approve'}>
                  <Button
                    onClick={() => showRejectionModel('approve')}
                    type="link"
                    icon={<FileDoneOutlined />}
                    style={{
                      color: '#13c2c2',
                    }}
                  >
                  </Button>
                </Tooltip>{' '}
                <Modal
                  title={'Add Comment'}
                  visible={isRejectionModelOpen && rejectionKey === 'approve'}
                  onCancel={handleRejectionPopupCanacel}
                  footer={null}
                >
                  <RejectionPopup
                    type={'Approve'}
                    hide={setIsRejectionModelOpen}
                    id={id}
                    activationDate={activationDate}
                    expiryDate={expiryDate}
                  />
                </Modal>
                <Tooltip title="Reject" key={'Reject'}>
                  <Button
                    onClick={() => showRejectionModel('reject')}
                    type="link"
                    icon={<FileExcelOutlined />}
                    style={{
                      color: '#f5222d',
                    }}
                  >
                  </Button>
                </Tooltip>{' '}
                <Modal
                  title={'Add Comment'}
                  visible={isRejectionModelOpen && rejectionKey === 'reject'}
                  onCancel={handleRejectionPopupCanacel}
                  footer={null}
                >
                  <RejectionPopup
                    type={'Reject'}
                    hide={setIsRejectionModelOpen}
                    id={id}
                    activationDate={activationDate}
                    expiryDate={expiryDate}
                  />
                </Modal>
              </>
            )}
          </>
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            height: '540px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spin />
        </div>
      ) : (
        <ContractDetail
          contractData={sowContractDetailArr}
          isRejectionModelOpen={isRejectionModelOpen}
          title={
            <span
            // style={{ cursor: 'pointer' }}
            // onClick={() => navigate(`/clients/${clientId}`)}
            >
              SOW Number: {sowNo ? sowNo : 'N/A'}
            </span>
          }
          popUpComponent={
            <Flex gap={5}>
              {(contractStatus === 'draft' ||
                contractStatus === 'pendingapproval' ||
                contractStatus === 'inactive') &&
                userRole !== 'finance' && (
                  <>
                    <Tooltip title="Edit" key={'Edit'}>
                      <Button
                        onClick={() => showModal(id)}
                        type="link"
                        icon={<EditOutlined />}
                        style={{ color: '#1677ff' }}
                      ></Button>
                    </Tooltip>
                    <SowDrawer
                      open={isModalOpen && selectedKey === id}
                      contractId={id}
                      onClose={handlePopupCancel}
                    />
                  </>
                )}

              {userRole !== 'finance' && (
                <Tooltip title="Add PO" key={'Add PO'}>
                  <Button
                    onClick={() => showRejectionModel('PO')}
                    type="link"
                    icon={<FilePptOutlined />}
                    style={{
                      // backgroundColor: '#f5222d',
                      color: '#fa8c16',
                    }}
                  >
                    {/* Reject */}
                  </Button>
                </Tooltip>
              )}
              <PoDrawer
                open={isRejectionModelOpen && rejectionKey === 'PO'}
                onClose={handleRejectionPopupCanacel}
                prefill={{
                  seId: seId,
                  clientName: sowContractDetailArr.find((item) => item.key === 'client')?.labelValue,
                  clientId: clientId,
                  projectName: sowContractDetailArr.find((item) => item.key === 'project')?.labelValue,
                  projectId: sowContractDetailArr.find((item) => item.key === 'project')?.redirectionURL.split('/')[2],
                  sowNumber: sowNo,
                }}
              />

              {userRole !== 'finance' && (
                <Tooltip title="Add CR" key={'Add CR'}>
                  <Button
                    onClick={() => showRejectionModel('CR')}
                    type="link"
                    icon={<FileTextOutlined />}
                    style={{
                      // backgroundColor: '#f5222d',
                      color: '#eb2f96',
                    }}
                  >
                    {/* Reject */}
                  </Button>
                </Tooltip>
              )}
              <CrDrawer
                open={isRejectionModelOpen && rejectionKey === 'CR'}
                onClose={handleRejectionPopupCanacel}
                prefill={{
                  seId: seId,
                  clientName: sowContractDetailArr.find((item) => item.key === 'client')?.labelValue,
                  clientId: clientId,
                  projectName: sowContractDetailArr.find((item) => item.key === 'project')?.labelValue,
                  projectId: sowContractDetailArr.find((item) => item.key === 'project')?.redirectionURL.split('/')[2],
                  sowNumber: sowNo,
                }}
              />
              {approvalButtons()}
            </Flex>
          }
        />
      )}
    </>
  );
};

export default SowDetail;
